import './Spinner.css';
import { spinnerState } from '../../states';
import { useRecoilState } from 'recoil';
import spinnerGif2 from '../../utils/images/spinnerGIF2.gif'
import { useEffect, useState } from 'react';


export const Spinner = ({ spinnerFlag }: { spinnerFlag?: boolean }) => {
    const [{ spinners, opacity }] = useRecoilState(spinnerState);
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        const img = new Image();
        img.src = spinnerGif2;
        img.onload = () => setImageLoaded(true);
    }, []);
    return (
        <>
            {(spinnerFlag || spinners.length > 0) &&
                <div className={`spinner-wrapper1 ${opacity ? 'spinner-opacity' : ''}`} style={{ visibility: imageLoaded ? 'visible' : 'hidden' }}>
                    <div className="spinner-overlay1 d-flex justify-content-center align-items-center">
                        <div className="w-100">
                            <img src={spinnerGif2} alt="spinner" className="spinner-size" />
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
